"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsOptionalIf = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const SkipValidationsIf_1 = require("./SkipValidationsIf");
/**
 * Skip validations if field value is nil and conditions are passed
 * NOTE: Async conditions are not supported here
 */
function IsOptionalIf(condition, options) {
    const conditions = [].concat(condition);
    conditions.push((value) => (0, isNil_1.default)(value));
    return (0, SkipValidationsIf_1.SkipValidationsIf)(conditions, options);
}
exports.IsOptionalIf = IsOptionalIf;
//# sourceMappingURL=IsOptionalIf.js.map